export const CHART_MIN_TICK_INTERVAL = 0.5;



// WEBPACK FOOTER //
// ./src/constants/charts.js